import { Profession } from '@/enums/profession';
import type { TaskProfession } from '@/types/data';

export const midnightFishing: TaskProfession = {
    id: Profession.Fishing,
    subProfessionId: 2911,
};

export const dragonflightFishing: TaskProfession = {
    id: Profession.Fishing,
    subProfessionId: 2826,
};
